import { Container, Typography, Paper, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/layout/StaticPageLayout';

export default function TermsOfService() {
  return (
    <StaticPageLayout>
      <Helmet>
        <title>Terms of Service - ET-Business Directory | Usage Guidelines</title>
        <meta name="description" content="Read ET-Business Directory's terms of service. Understand our platform's usage guidelines, business listing policies, and user responsibilities for Ethiopia's leading business directory." />
      </Helmet>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper sx={{ p: 4, borderRadius: '12px' }}>
              <Typography variant="h4" sx={{ color: '#3A551A', mb: 4, fontWeight: 600 }}>
                Terms of Service
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Agreement to Terms
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                By accessing and using ET-Business Directory, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our service.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Business Listing Guidelines
              </Typography>
              <Typography variant="h6" sx={{ color: '#3A551A', mb: 2 }}>
                Listing Requirements
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>All business listings must be legitimate and legally operating in Ethiopia</li>
                <li>Business information must be accurate and up-to-date</li>
                <li>Contact information must be valid and operational</li>
                <li>Business descriptions must be truthful and not misleading</li>
                <li>Categories must accurately reflect the business type</li>
              </ul>

              <Typography variant="h6" sx={{ color: '#3A551A', mb: 2 }}>
                Prohibited Content
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>False or misleading information</li>
                <li>Offensive or inappropriate content</li>
                <li>Spam or promotional content</li>
                <li>Content that violates Ethiopian laws</li>
                <li>Duplicate listings for the same business</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                User Responsibilities
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                Users of ET-Business Directory agree to:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Provide accurate and current information</li>
                <li>Maintain the security of their account credentials</li>
                <li>Not misuse or attempt to manipulate the platform</li>
                <li>Report any violations or suspicious activities</li>
                <li>Respect the intellectual property rights of others</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Service Modifications
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, color: '#444', lineHeight: 1.8 }}>
                ET-Business Directory reserves the right to:
              </Typography>
              <ul style={{ color: '#444', marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                <li>Modify or discontinue any part of the service</li>
                <li>Update these terms of service as needed</li>
                <li>Remove or edit content that violates these terms</li>
                <li>Suspend or terminate accounts for violations</li>
              </ul>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Intellectual Property
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                The content, organization, graphics, design, and other matters related to ET-Business Directory are protected under applicable copyrights and other proprietary laws. The copying, redistribution, use, or publication of any such matters or any part of the platform is prohibited without our express permission.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Limitation of Liability
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                ET-Business Directory shall not be liable for any damages arising from the use or inability to use our services. We do not guarantee the accuracy, completeness, or usefulness of any information on the platform.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Governing Law
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                These terms shall be governed by and construed in accordance with the laws of Ethiopia, without regard to its conflict of law provisions.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Contact Information
              </Typography>
              <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.8 }}>
                If you have any questions about these Terms of Service, please contact us at:
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, color: '#444', lineHeight: 1.8 }}>
                Email: <a href="mailto:legal@et-business.com" style={{ color: '#3A551A', textDecoration: 'none' }}>legal@et-business.com</a><br />
                Phone: <a href="tel:+251123456789" style={{ color: '#3A551A', textDecoration: 'none' }}>+251 123 456 789</a><br />
                Address: Bole Road, Addis Ababa, Ethiopia
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </StaticPageLayout>
  );
} 